export default "__VITE_ASSET__CDDs6LgC__"